import React, { useCallback, useState, useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { usePickingControlDataState } from '../../../stores/PickingControlDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { BsFillLockFill } from "react-icons/bs";
import { PdfButton } from '../../Buttons/PdfButton'
import useReport from '../../../utils/hooks/useReport'
import DownloadURLAlert from '../../Forms/DownloadURLAlert'
import ReportSubscriptionModal from '../../Files/Form/ReportSubscriptionModal'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { useParams } from 'react-router-dom'
import ArticleScan from '../ArticleScan'
import { BiBarcodeReader } from 'react-icons/bi'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`
const StyledCancelButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const StyledScanButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const PickingControlSidebar = () => {
  const {
    headerData, checkStatusHasBeenPicked, lockInfo,
    submitPartialPicking, submitHasBeenPicked,
    partialPickingIsEnabled, hasBeenPickedIsEnabled, allPositionsHaveBeenPicked,
    errorsOccurredOnSubmit,
    formDataHasChanged,
    resetFormData,
    setSuccessSubmit,
    successSubmit,
    loadOrderData, addScannedArticle,
    hasBeenPickedResult,
  } = usePickingControlDataState()
  const { createReport, reportIsLoading, reportErrors, reportDownloadUrls, setReportDownloadUrls, reportSubscriptionId, setReportSubscriptionId } = useReport()
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving,] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false)
  const [isSaving2, setIsSaving2,] = useState(false)
  const [openScanModal, setOpenScanModal,] = useState(false)
  const { soId } = useParams()
  const handleSubmit = useCallback(async e => {
    setSuccessSubmit(false)
    setIsLoading(true)
    setIsSaving(true)
    await submitPartialPicking()
    setIsSaving(false)
    setIsLoading(false)
  }, [setSuccessSubmit, submitPartialPicking])

  const handleSubmitHasBeenPicked = useCallback(async e => {
    setSuccessSubmit(false)
    setIsLoading2(true)
    setIsSaving2(true)
    await submitHasBeenPicked()
    setIsSaving2(false)
    setIsLoading2(false)
  }, [setSuccessSubmit, submitHasBeenPicked])

  const handleClickCancel = () => {
    resetFormData();
  }
  useEffect(() => {
    let timeout = null
    if (!isLoading && !!successSubmit) {
      timeout = setTimeout(() => {
        setSuccessSubmit(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, successSubmit, setSuccessSubmit])

  const { t } = useTranslation()
  const isLocked = () => {
    if (lockInfo && !lockInfo?.lockedByUser) return true
    return false
  }
  const hasBeenPicked = () => {
    if (checkStatusHasBeenPicked()) return true;
    return false;
  }
  const { deliveySlipIsAvailable, packagelabelIsAvailable } = hasBeenPickedResult
  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('pickingOverlayProgress:headerControl')}</div>
      </header>
      <div className="content">
        <StyledScanButton className="mb-3"
          onClick={() => setOpenScanModal(true)}
          disabled={isLoading || !loadOrderData || isLocked() || hasBeenPicked() || allPositionsHaveBeenPicked}
        >
          <BiBarcodeReader className='me-3' />
          {t('productsOverview:articleScan')}
        </StyledScanButton>
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={isLoading || !loadOrderData || isLocked() || !partialPickingIsEnabled || hasBeenPicked()}
          buttonText={t('OverlayProgress:save')}
          loadingText={t('OverlayProgress:save')}
        />
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isLoading2}
          onClick={handleSubmitHasBeenPicked}
          disabled={isLoading2 || !loadOrderData || isLocked() || !hasBeenPickedIsEnabled || hasBeenPicked()}
          buttonText={t('pickingOverlayProgress:confirmPickingControl')}
          loadingText={t('pickingOverlayProgress:confirmPickingControl')}
        />
        {(formDataHasChanged) && (
          <>
            <StyledCancelButton className="mb-3" variant="secondary" onClick={handleClickCancel}>{t('cancelButton')}</StyledCancelButton>
            <div className=" alert alert-info" >{t('EmployeeFormHealthData:dataChange')}</div>
          </>
        )}
        {deliveySlipIsAvailable && <PdfButton
          variant='secondary'
          onClick={() => createReport("deliverySlip", APIEndpoints.withdrawals(soId).printDeliverySlip, {})}
          isLoading={reportIsLoading.deliverySlip}
          buttonText={t('withdrawalsTable:printDeliverySlip')}
        />}
        {deliveySlipIsAvailable && packagelabelIsAvailable && <div className="mb-3" />}
        {packagelabelIsAvailable && <PdfButton
          variant='secondary'
          onClick={() => createReport("packagelabel", APIEndpoints.withdrawals(soId).printPackagelabel, {})}
          isLoading={reportIsLoading.deliverySlip}
          buttonText={t('withdrawalsTable:printPackagelabel')}
        />}
        <div className="mb-5" />
        {isLocked() && (
          <Alert variant="info">
            <BsFillLockFill color="#000000" /> {`${t('withdrawalsTable:lockedBy')} ${headerData.lockInfo?.creator?.displayName}`}
          </Alert>
        )}
        {(!isLoading && !isSaving && !isLoading2 && !isSaving2 && !!errorsOccurredOnSubmit) && (
          <Alert variant="danger">
            <Trans i18nKey='pickingOverlayProgress:danger' />
          </Alert>
        )}
        {(!isLoading && !isSaving && !isLoading2 && !isSaving2 && !!successSubmit) && (
          <Alert variant="success">
            {t('pickingOverlayProgress:pickingControlSucceeded')}
          </Alert>
        )}
        {reportErrors.deliverySlip && <Alert variant="danger">{reportErrors.deliverySlip.value}</Alert>}
        {reportDownloadUrls.deliverySlip &&
          <DownloadURLAlert
            downloadUrl={reportDownloadUrls.deliverySlip}
            setDownloadUrl={() => setReportDownloadUrls({})}
            fileName={t('withdrawalsTable:fileNameDeliverySlip')}
          />
        }
        {reportErrors.packagelabel && <Alert variant="danger">{reportErrors.packagelabel.value}</Alert>}
        {reportDownloadUrls.packagelabel &&
          <DownloadURLAlert
            downloadUrl={reportDownloadUrls.packagelabel}
            setDownloadUrl={() => setReportDownloadUrls({})}
            fileName={t('withdrawalsTable:fileNamePackagelabel')}
          />
        }
        {reportSubscriptionId && <ReportSubscriptionModal
          reportSubscriptionId={reportSubscriptionId}
          setReportSubscriptionId={setReportSubscriptionId}
          message={t('reportConfig:createPending')}
        />}
      </div>
      {openScanModal && (
        <ArticleScan
          handleClose={() => setOpenScanModal(false)}
          shippingOrderId={soId}
          addScannedArticle={addScannedArticle}
        />
      )}
    </StyledContainer>
  )
}

export default PickingControlSidebar
